/* eslint-disable */
//
// This file is auto-generated by build.ts
// Do not modify manually, please do: bun run wasm
//

/**
 * Mapping from original function names to minified WASM export names.
 * Using const enum so values are inlined at compile time.
 */
export const enum PdfiumExports {
  __assert_fail = "I",
  __cxa_throw = "h",
  __indirect_function_table = "W",
  __syscall_fcntl64 = "e",
  __syscall_fstat64 = "G",
  __syscall_ftruncate64 = "A",
  __syscall_getdents64 = "u",
  __syscall_ioctl = "H",
  __syscall_lstat64 = "E",
  __syscall_newfstatat = "D",
  __syscall_openat = "f",
  __syscall_rmdir = "s",
  __syscall_stat64 = "F",
  __syscall_unlinkat = "t",
  __wasm_call_ctors = "K",
  _abort_js = "i",
  _emscripten_runtime_keepalive_clear = "n",
  _emscripten_stack_restore = "ri",
  _emscripten_throw_longjmp = "p",
  _emscripten_timeout = "pi",
  _gmtime_js = "v",
  _localtime_js = "w",
  _setitimer_js = "o",
  _tzset_js = "j",
  emscripten_builtin_memalign = "oi",
  emscripten_date_now = "g",
  emscripten_resize_heap = "q",
  emscripten_stack_get_current = "si",
  environ_get = "y",
  environ_sizes_get = "z",
  fd_close = "a",
  fd_read = "d",
  fd_seek = "x",
  fd_sync = "B",
  fd_write = "c",
  FORM_CanRedo = "Ie",
  FORM_CanUndo = "He",
  FORM_DoDocumentAAction = "We",
  FORM_DoDocumentJSAction = "Ue",
  FORM_DoDocumentOpenAction = "Ve",
  FORM_DoPageAAction = "Xe",
  FORM_ForceToKillFocus = "Le",
  FORM_GetFocusedAnnot = "Me",
  FORM_GetFocusedText = "Ce",
  FORM_GetSelectedText = "De",
  FORM_IsIndexSelected = "Ze",
  FORM_OnAfterLoadPage = "Se",
  FORM_OnBeforeClosePage = "Te",
  FORM_OnChar = "Be",
  FORM_OnFocus = "te",
  FORM_OnKeyDown = "ze",
  FORM_OnKeyUp = "Ae",
  FORM_OnLButtonDoubleClick = "we",
  FORM_OnLButtonDown = "ue",
  FORM_OnLButtonUp = "ve",
  FORM_OnMouseMove = "re",
  FORM_OnMouseWheel = "se",
  FORM_OnRButtonDown = "xe",
  FORM_OnRButtonUp = "ye",
  FORM_Redo = "Ke",
  FORM_ReplaceAndKeepSelection = "Ee",
  FORM_ReplaceSelection = "Fe",
  FORM_SelectAllText = "Ge",
  FORM_SetFocusedAnnot = "Ne",
  FORM_SetIndexSelected = "Ye",
  FORM_Undo = "Je",
  FPDF_AddInstalledFont = "eg",
  FPDF_CloseDocument = "Q",
  FPDF_ClosePage = "Nh",
  FPDF_CloseXObject = "hf",
  FPDF_CopyViewerPreferences = "kf",
  FPDF_CountNamedDests = "hi",
  FPDF_CreateClipPath = "mh",
  FPDF_CreateNewDocument = "P",
  FPDF_DestroyClipPath = "nh",
  FPDF_DestroyLibrary = "rh",
  FPDF_DeviceToPage = "Ph",
  FPDF_DocumentHasValidCrossReferenceTable = "Ah",
  FPDF_FFLDraw = "Oe",
  FPDF_FreeDefaultSystemFontInfo = "kg",
  FPDF_GetDefaultSystemFontInfo = "jg",
  FPDF_GetDefaultTTFMap = "gg",
  FPDF_GetDefaultTTFMapCount = "hg",
  FPDF_GetDefaultTTFMapEntry = "ig",
  FPDF_GetDocPermissions = "Bh",
  FPDF_GetDocUserPermissions = "Ch",
  FPDF_GetFileIdentifier = "bc",
  FPDF_GetFileVersion = "zh",
  FPDF_GetFormType = "uh",
  FPDF_GetLastError = "Oh",
  FPDF_GetMetaText = "cc",
  FPDF_GetNamedDest = "ji",
  FPDF_GetNamedDestByName = "ii",
  FPDF_GetPageAAction = "ac",
  FPDF_GetPageBoundingBox = "Kh",
  FPDF_GetPageCount = "Eh",
  FPDF_GetPageHeight = "Jh",
  FPDF_GetPageHeightF = "Ih",
  FPDF_GetPageLabel = "dc",
  FPDF_GetPageSizeByIndex = "$h",
  FPDF_GetPageSizeByIndexF = "_h",
  FPDF_GetPageWidth = "Hh",
  FPDF_GetPageWidthF = "Gh",
  FPDF_GetSecurityHandlerRevision = "Dh",
  FPDF_GetSignatureCount = "tf",
  FPDF_GetSignatureObject = "uf",
  FPDF_GetTrailerEnds = "ni",
  FPDF_GetXFAPacketContent = "mi",
  FPDF_GetXFAPacketCount = "ki",
  FPDF_GetXFAPacketName = "li",
  FPDF_ImportNPagesToOne = "ff",
  FPDF_ImportPages = "ef",
  FPDF_ImportPagesByIndex = "df",
  FPDF_InitLibrary = "ph",
  FPDF_InitLibraryWithConfig = "qh",
  FPDF_LoadCustomDocument = "yh",
  FPDF_LoadDocument = "th",
  FPDF_LoadMemDocument = "wh",
  FPDF_LoadMemDocument64 = "xh",
  FPDF_LoadPage = "Fh",
  FPDF_LoadXFA = "vh",
  FPDF_MovePages = "tc",
  FPDF_NewFormObjectFromXObject = "jf",
  FPDF_NewXObjectFromPage = "gf",
  FPDF_PageToDevice = "Qh",
  FPDF_RemoveFormFieldHighlight = "Re",
  FPDF_RenderPage_Close = "of",
  FPDF_RenderPage_Continue = "nf",
  FPDF_RenderPageBitmap = "Lh",
  FPDF_RenderPageBitmap_Start = "mf",
  FPDF_RenderPageBitmapWithColorScheme_Start = "lf",
  FPDF_RenderPageBitmapWithMatrix = "Mh",
  FPDF_SaveAsCopy = "pf",
  FPDF_SaveWithVersion = "qf",
  FPDF_SetFormFieldHighlightAlpha = "Qe",
  FPDF_SetFormFieldHighlightColor = "Pe",
  FPDF_SetSandBoxPolicy = "sh",
  FPDF_SetSystemFontInfo = "fg",
  FPDF_StructElement_Attr_CountChildren = "ag",
  FPDF_StructElement_Attr_GetBlobValue = "$f",
  FPDF_StructElement_Attr_GetBooleanValue = "Yf",
  FPDF_StructElement_Attr_GetChildAtIndex = "bg",
  FPDF_StructElement_Attr_GetCount = "Uf",
  FPDF_StructElement_Attr_GetName = "Vf",
  FPDF_StructElement_Attr_GetNumberValue = "Zf",
  FPDF_StructElement_Attr_GetStringValue = "_f",
  FPDF_StructElement_Attr_GetType = "Xf",
  FPDF_StructElement_Attr_GetValue = "Wf",
  FPDF_StructElement_CountChildren = "Qf",
  FPDF_StructElement_GetActualText = "Gf",
  FPDF_StructElement_GetAltText = "Ff",
  FPDF_StructElement_GetAttributeAtIndex = "Kf",
  FPDF_StructElement_GetAttributeCount = "Jf",
  FPDF_StructElement_GetChildAtIndex = "Rf",
  FPDF_StructElement_GetChildMarkedContentID = "Sf",
  FPDF_StructElement_GetID = "Hf",
  FPDF_StructElement_GetLang = "If",
  FPDF_StructElement_GetMarkedContentID = "Mf",
  FPDF_StructElement_GetMarkedContentIdAtIndex = "dg",
  FPDF_StructElement_GetMarkedContentIdCount = "cg",
  FPDF_StructElement_GetObjType = "Of",
  FPDF_StructElement_GetParent = "Tf",
  FPDF_StructElement_GetStringAttribute = "Lf",
  FPDF_StructElement_GetTitle = "Pf",
  FPDF_StructElement_GetType = "Nf",
  FPDF_StructTree_Close = "Cf",
  FPDF_StructTree_CountChildren = "Df",
  FPDF_StructTree_GetChildAtIndex = "Ef",
  FPDF_StructTree_GetForPage = "Bf",
  FPDF_VIEWERREF_GetDuplex = "fi",
  FPDF_VIEWERREF_GetName = "gi",
  FPDF_VIEWERREF_GetNumCopies = "bi",
  FPDF_VIEWERREF_GetPrintPageRange = "ci",
  FPDF_VIEWERREF_GetPrintPageRangeCount = "di",
  FPDF_VIEWERREF_GetPrintPageRangeElement = "ei",
  FPDF_VIEWERREF_GetPrintScaling = "ai",
  FPDFAction_GetDest = "Nb",
  FPDFAction_GetFilePath = "Ob",
  FPDFAction_GetType = "Mb",
  FPDFAction_GetURIPath = "Pb",
  FPDFAnnot_AddFileAttachment = "ib",
  FPDFAnnot_AddInkStroke = "ha",
  FPDFAnnot_AppendAttachmentPoints = "ra",
  FPDFAnnot_AppendObject = "ja",
  FPDFAnnot_CountAttachmentPoints = "sa",
  FPDFAnnot_GetAP = "Ia",
  FPDFAnnot_GetAttachmentPoints = "ta",
  FPDFAnnot_GetBorder = "Ba",
  FPDFAnnot_GetColor = "oa",
  FPDFAnnot_GetFileAttachment = "hb",
  FPDFAnnot_GetFlags = "Ka",
  FPDFAnnot_GetFocusableSubtypes = "bb",
  FPDFAnnot_GetFocusableSubtypesCount = "ab",
  FPDFAnnot_GetFontColor = "Za",
  FPDFAnnot_GetFontSize = "Xa",
  FPDFAnnot_GetFormAdditionalActionJavaScript = "Ra",
  FPDFAnnot_GetFormControlCount = "db",
  FPDFAnnot_GetFormControlIndex = "eb",
  FPDFAnnot_GetFormFieldAlternateName = "Sa",
  FPDFAnnot_GetFormFieldAtPoint = "Oa",
  FPDFAnnot_GetFormFieldExportValue = "fb",
  FPDFAnnot_GetFormFieldFlags = "Ma",
  FPDFAnnot_GetFormFieldName = "Pa",
  FPDFAnnot_GetFormFieldType = "Qa",
  FPDFAnnot_GetFormFieldValue = "Ta",
  FPDFAnnot_GetInkListCount = "xa",
  FPDFAnnot_GetInkListPath = "ya",
  FPDFAnnot_GetLine = "za",
  FPDFAnnot_GetLink = "cb",
  FPDFAnnot_GetLinkedAnnot = "Ja",
  FPDFAnnot_GetNumberValue = "Ga",
  FPDFAnnot_GetObject = "la",
  FPDFAnnot_GetObjectCount = "ka",
  FPDFAnnot_GetOptionCount = "Ua",
  FPDFAnnot_GetOptionLabel = "Va",
  FPDFAnnot_GetRect = "va",
  FPDFAnnot_GetStringValue = "Fa",
  FPDFAnnot_GetSubtype = "ea",
  FPDFAnnot_GetValueType = "Da",
  FPDFAnnot_GetVertices = "wa",
  FPDFAnnot_HasAttachmentPoints = "pa",
  FPDFAnnot_HasKey = "Ca",
  FPDFAnnot_IsChecked = "_a",
  FPDFAnnot_IsObjectSupportedSubtype = "fa",
  FPDFAnnot_IsOptionSelected = "Wa",
  FPDFAnnot_IsSupportedSubtype = "Z",
  FPDFAnnot_RemoveInkList = "ia",
  FPDFAnnot_RemoveObject = "ma",
  FPDFAnnot_SetAP = "Ha",
  FPDFAnnot_SetAttachmentPoints = "qa",
  FPDFAnnot_SetBorder = "Aa",
  FPDFAnnot_SetColor = "na",
  FPDFAnnot_SetFlags = "La",
  FPDFAnnot_SetFocusableSubtypes = "$a",
  FPDFAnnot_SetFontColor = "Ya",
  FPDFAnnot_SetFormFieldFlags = "Na",
  FPDFAnnot_SetRect = "ua",
  FPDFAnnot_SetStringValue = "Ea",
  FPDFAnnot_SetURI = "gb",
  FPDFAnnot_UpdateObject = "ga",
  FPDFAttachment_GetFile = "tb",
  FPDFAttachment_GetName = "nb",
  FPDFAttachment_GetStringValue = "rb",
  FPDFAttachment_GetSubtype = "ub",
  FPDFAttachment_GetValueType = "pb",
  FPDFAttachment_HasKey = "ob",
  FPDFAttachment_SetFile = "sb",
  FPDFAttachment_SetStringValue = "qb",
  FPDFAvail_Create = "xb",
  FPDFAvail_Destroy = "yb",
  FPDFAvail_GetDocument = "Ab",
  FPDFAvail_GetFirstPageNum = "Bb",
  FPDFAvail_IsDocAvail = "zb",
  FPDFAvail_IsFormAvail = "Db",
  FPDFAvail_IsLinearized = "Eb",
  FPDFAvail_IsPageAvail = "Cb",
  FPDFBitmap_Create = "Rh",
  FPDFBitmap_CreateEx = "Sh",
  FPDFBitmap_Destroy = "Zh",
  FPDFBitmap_FillRect = "Uh",
  FPDFBitmap_GetBuffer = "Vh",
  FPDFBitmap_GetFormat = "Th",
  FPDFBitmap_GetHeight = "Xh",
  FPDFBitmap_GetStride = "Yh",
  FPDFBitmap_GetWidth = "Wh",
  FPDFBookmark_Find = "Jb",
  FPDFBookmark_GetAction = "Lb",
  FPDFBookmark_GetCount = "Ib",
  FPDFBookmark_GetDest = "Kb",
  FPDFBookmark_GetFirstChild = "Fb",
  FPDFBookmark_GetNextSibling = "Gb",
  FPDFBookmark_GetTitle = "Hb",
  FPDFCatalog_IsTagged = "vb",
  FPDFCatalog_SetLanguage = "wb",
  FPDFClipPath_CountPaths = "jh",
  FPDFClipPath_CountPathSegments = "kh",
  FPDFClipPath_GetPathSegment = "lh",
  FPDFDest_GetDestPageIndex = "Qb",
  FPDFDest_GetLocationInPage = "Sb",
  FPDFDest_GetView = "Rb",
  FPDFDoc_AddAttachment = "kb",
  FPDFDoc_CloseJavaScriptAction = "af",
  FPDFDoc_DeleteAttachment = "mb",
  FPDFDOC_ExitFormFillEnvironment = "qe",
  FPDFDoc_GetAttachment = "lb",
  FPDFDoc_GetAttachmentCount = "jb",
  FPDFDoc_GetJavaScriptAction = "$e",
  FPDFDoc_GetJavaScriptActionCount = "_e",
  FPDFDoc_GetPageMode = "le",
  FPDFDOC_InitFormFillEnvironment = "pe",
  FPDFFont_Close = "Vd",
  FPDFFont_GetAscent = "fe",
  FPDFFont_GetBaseFontName = "_d",
  FPDFFont_GetDescent = "ge",
  FPDFFont_GetFamilyName = "$d",
  FPDFFont_GetFlags = "ce",
  FPDFFont_GetFontData = "ae",
  FPDFFont_GetGlyphPath = "ie",
  FPDFFont_GetGlyphWidth = "he",
  FPDFFont_GetIsEmbedded = "be",
  FPDFFont_GetItalicAngle = "ee",
  FPDFFont_GetWeight = "de",
  FPDFFormObj_CountObjects = "wd",
  FPDFFormObj_GetObject = "xd",
  FPDFFormObj_RemoveObject = "yd",
  FPDFGlyphPath_CountGlyphSegments = "je",
  FPDFGlyphPath_GetGlyphPathSegment = "ke",
  FPDFImageObj_GetBitmap = "jc",
  FPDFImageObj_GetIccProfileDataDecoded = "rc",
  FPDFImageObj_GetImageDataDecoded = "lc",
  FPDFImageObj_GetImageDataRaw = "mc",
  FPDFImageObj_GetImageFilter = "oc",
  FPDFImageObj_GetImageFilterCount = "nc",
  FPDFImageObj_GetImageMetadata = "pc",
  FPDFImageObj_GetImagePixelSize = "qc",
  FPDFImageObj_GetRenderedBitmap = "kc",
  FPDFImageObj_LoadJpegFile = "fc",
  FPDFImageObj_LoadJpegFileInline = "gc",
  FPDFImageObj_SetBitmap = "ic",
  FPDFImageObj_SetMatrix = "hc",
  FPDFJavaScriptAction_GetName = "bf",
  FPDFJavaScriptAction_GetScript = "cf",
  FPDFLink_CloseWebLinks = "Ug",
  FPDFLink_CountQuadPoints = "_b",
  FPDFLink_CountRects = "Rg",
  FPDFLink_CountWebLinks = "Pg",
  FPDFLink_Enumerate = "Xb",
  FPDFLink_GetAction = "Wb",
  FPDFLink_GetAnnot = "Yb",
  FPDFLink_GetAnnotRect = "Zb",
  FPDFLink_GetDest = "Vb",
  FPDFLink_GetLinkAtPoint = "Tb",
  FPDFLink_GetLinkZOrderAtPoint = "Ub",
  FPDFLink_GetQuadPoints = "$b",
  FPDFLink_GetRect = "Sg",
  FPDFLink_GetTextRange = "Tg",
  FPDFLink_GetURL = "Qg",
  FPDFLink_LoadWebLinks = "Og",
  FPDFPage_CloseAnnot = "ca",
  FPDFPage_CountObjects = "zc",
  FPDFPage_CreateAnnot = "_",
  FPDFPage_Delete = "sc",
  FPDFPage_Flatten = "me",
  FPDFPage_FormFieldZOrderAtPoint = "oe",
  FPDFPage_GenerateContent = "Zc",
  FPDFPage_GetAnnot = "aa",
  FPDFPage_GetAnnotCount = "$",
  FPDFPage_GetAnnotIndex = "ba",
  FPDFPage_GetArtBox = "fh",
  FPDFPage_GetBleedBox = "dh",
  FPDFPage_GetCropBox = "ch",
  FPDFPage_GetDecodedThumbnailData = "Vg",
  FPDFPage_GetMediaBox = "bh",
  FPDFPage_GetObject = "Ac",
  FPDFPage_GetRawThumbnailData = "Wg",
  FPDFPage_GetRotation = "vc",
  FPDFPage_GetThumbnailAsBitmap = "Xg",
  FPDFPage_GetTrimBox = "eh",
  FPDFPage_HasFormFieldAtPoint = "ne",
  FPDFPage_HasTransparency = "Bc",
  FPDFPage_InsertClipPath = "oh",
  FPDFPage_InsertObject = "wc",
  FPDFPage_InsertObjectAtIndex = "xc",
  FPDFPage_New = "uc",
  FPDFPage_RemoveAnnot = "da",
  FPDFPage_RemoveObject = "yc",
  FPDFPage_SetArtBox = "ah",
  FPDFPage_SetBleedBox = "_g",
  FPDFPage_SetCropBox = "Zg",
  FPDFPage_SetMediaBox = "Yg",
  FPDFPage_SetRotation = "ed",
  FPDFPage_SetTrimBox = "$g",
  FPDFPage_TransformAnnots = "dd",
  FPDFPage_TransFormWithClip = "gh",
  FPDFPageObj_AddMark = "Gc",
  FPDFPageObj_CountMarks = "Ec",
  FPDFPageObj_CreateNewPath = "zd",
  FPDFPageObj_CreateNewRect = "Ad",
  FPDFPageObj_CreateTextObj = "Wd",
  FPDFPageObj_Destroy = "Cc",
  FPDFPageObj_GetBounds = "hd",
  FPDFPageObj_GetClipPath = "ih",
  FPDFPageObj_GetDashArray = "ud",
  FPDFPageObj_GetDashCount = "td",
  FPDFPageObj_GetDashPhase = "rd",
  FPDFPageObj_GetFillColor = "gd",
  FPDFPageObj_GetIsActive = "Xc",
  FPDFPageObj_GetLineCap = "pd",
  FPDFPageObj_GetLineJoin = "nd",
  FPDFPageObj_GetMark = "Fc",
  FPDFPageObj_GetMarkedContentID = "Dc",
  FPDFPageObj_GetMatrix = "ad",
  FPDFPageObj_GetRotatedBounds = "id",
  FPDFPageObj_GetStrokeColor = "kd",
  FPDFPageObj_GetStrokeWidth = "md",
  FPDFPageObj_GetType = "Wc",
  FPDFPageObj_HasTransparency = "Qc",
  FPDFPageObj_NewImageObj = "ec",
  FPDFPageObj_NewTextObj = "Md",
  FPDFPageObj_RemoveMark = "Hc",
  FPDFPageObj_SetBlendMode = "cd",
  FPDFPageObj_SetDashArray = "vd",
  FPDFPageObj_SetDashPhase = "sd",
  FPDFPageObj_SetFillColor = "fd",
  FPDFPageObj_SetIsActive = "Yc",
  FPDFPageObj_SetLineCap = "qd",
  FPDFPageObj_SetLineJoin = "od",
  FPDFPageObj_SetMatrix = "bd",
  FPDFPageObj_SetStrokeColor = "jd",
  FPDFPageObj_SetStrokeWidth = "ld",
  FPDFPageObj_Transform = "_c",
  FPDFPageObj_TransformClipPath = "hh",
  FPDFPageObj_TransformF = "$c",
  FPDFPageObjMark_CountParams = "Jc",
  FPDFPageObjMark_GetName = "Ic",
  FPDFPageObjMark_GetParamBlobValue = "Pc",
  FPDFPageObjMark_GetParamFloatValue = "Nc",
  FPDFPageObjMark_GetParamIntValue = "Mc",
  FPDFPageObjMark_GetParamKey = "Kc",
  FPDFPageObjMark_GetParamStringValue = "Oc",
  FPDFPageObjMark_GetParamValueType = "Lc",
  FPDFPageObjMark_RemoveParam = "Vc",
  FPDFPageObjMark_SetBlobParam = "Uc",
  FPDFPageObjMark_SetFloatParam = "Sc",
  FPDFPageObjMark_SetIntParam = "Rc",
  FPDFPageObjMark_SetStringParam = "Tc",
  FPDFPath_BezierTo = "Fd",
  FPDFPath_Close = "Gd",
  FPDFPath_CountSegments = "Bd",
  FPDFPath_GetDrawMode = "Id",
  FPDFPath_GetPathSegment = "Cd",
  FPDFPath_LineTo = "Ed",
  FPDFPath_MoveTo = "Dd",
  FPDFPath_SetDrawMode = "Hd",
  FPDFPathSegment_GetClose = "Ld",
  FPDFPathSegment_GetPoint = "Jd",
  FPDFPathSegment_GetType = "Kd",
  FPDFSignatureObj_GetByteRange = "wf",
  FPDFSignatureObj_GetContents = "vf",
  FPDFSignatureObj_GetDocMDPPermission = "Af",
  FPDFSignatureObj_GetReason = "yf",
  FPDFSignatureObj_GetSubFilter = "xf",
  FPDFSignatureObj_GetTime = "zf",
  FPDFText_ClosePage = "mg",
  FPDFText_CountChars = "ng",
  FPDFText_CountRects = "Fg",
  FPDFText_FindClose = "Ng",
  FPDFText_FindNext = "Jg",
  FPDFText_FindPrev = "Kg",
  FPDFText_FindStart = "Ig",
  FPDFText_GetBoundedText = "Hg",
  FPDFText_GetCharAngle = "yg",
  FPDFText_GetCharBox = "zg",
  FPDFText_GetCharIndexAtPos = "Dg",
  FPDFText_GetCharIndexFromTextIndex = "rf",
  FPDFText_GetCharOrigin = "Cg",
  FPDFText_GetFillColor = "wg",
  FPDFText_GetFontInfo = "ug",
  FPDFText_GetFontSize = "tg",
  FPDFText_GetFontWeight = "vg",
  FPDFText_GetLooseCharBox = "Ag",
  FPDFText_GetMatrix = "Bg",
  FPDFText_GetRect = "Gg",
  FPDFText_GetSchCount = "Mg",
  FPDFText_GetSchResultIndex = "Lg",
  FPDFText_GetStrokeColor = "xg",
  FPDFText_GetText = "Eg",
  FPDFText_GetTextIndexFromCharIndex = "sf",
  FPDFText_GetTextObject = "pg",
  FPDFText_GetUnicode = "og",
  FPDFText_HasUnicodeMapError = "sg",
  FPDFText_IsGenerated = "qg",
  FPDFText_IsHyphen = "rg",
  FPDFText_LoadCidType2Font = "Rd",
  FPDFText_LoadFont = "Pd",
  FPDFText_LoadPage = "lg",
  FPDFText_LoadStandardFont = "Qd",
  FPDFText_SetCharcodes = "Od",
  FPDFText_SetText = "Nd",
  FPDFTextObj_GetFont = "Zd",
  FPDFTextObj_GetFontSize = "Sd",
  FPDFTextObj_GetRenderedBitmap = "Ud",
  FPDFTextObj_GetText = "Td",
  FPDFTextObj_GetTextRenderMode = "Xd",
  FPDFTextObj_SetTextRenderMode = "Yd",
  free = "Y",
  invoke_ii = "r",
  invoke_iii = "b",
  invoke_iiii = "l",
  invoke_iiiii = "k",
  invoke_viii = "C",
  malloc = "X",
  memory = "J",
  PDFKING_CopyTransparencyGroup = "V",
  PDFKING_ExportPageObjects = "O",
  PDFKING_HelloWorld = "L",
  PDFKING_ICC_ConvertPage = "U",
  PDFKING_ICC_CreateTransform = "S",
  PDFKING_ICC_DestroyTransform = "T",
  PDFKING_PageObj_SetClipRect = "R",
  PDFKING_PageObj_SetFillColorCMYK = "M",
  PDFKING_PageObj_SetStrokeColorCMYK = "N",
  proc_exit = "m",
  setThrew = "qi",
}

/** Minified import module name */
export const IMPORT_MODULE = "a" as const
